import { Injectable } from '@angular/core';
// import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Usuario } from '../models/Usuario';
import 'rxjs/add/operator/map'
import { environment } from '../../environments/environment';
import { ServersService } from './servers.service';
import { HttpCacheService } from './httpcache.service';

@Injectable()
export class VehiculoService {
    constructor(private http: HttpCacheService, private servers: ServersService) { }

    getByPlaca(placa:any, callback: any) {

        return this.http.get(0, this.servers.serverName + '/placa/'+placa+'/vehiculo', callback);
    }

    getByEmpresa(idEmpresa:any, callback: any) {

        return this.http.get(0, this.servers.serverName + '/empresa/'+idEmpresa+'/vehiculo', callback);
    }

    getAll( callback: any) {

        return this.http.get(0, this.servers.serverName + '/vehiculo', callback);
    }

    getTiposDeVehiculos(callback: any){
        return this.http.get(30, this.servers.serverName + '/tipoVehiculo',  callback);
    }

    save(object: any, callback: any) {
        return this.http.post(30, this.servers.serverName + '/vehiculo', object, callback);
    }
    update(object: any, callback: any) {
        return this.http.put(30, this.servers.serverName + '/vehiculo/'+object.id, object, callback);
    }

    updateState(object: any, callback: any) {
        var url = this.servers.serverName + '/vehiculo/update/state/' + object.id;
        return this.http.put(0,url,object, callback);
    }

}



// WEBPACK FOOTER //
// ./src/app/servicios/vehiculo.service.ts